import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaAngleDown } from 'react-icons/fa';


import FootpringSvg from '../../../assets/Footprints-Logo.svg';
import '../SideMenu/SideDrawer.css';



import {
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,


  Media,
  Tooltip,
} from 'reactstrap';


import { useAtom } from 'jotai';
import {
  activeChildDetail,
  appConstants,
  bell,
  changeChild,
  childList,
  parentProfile,
  sidebar,
  userstate,
} from '../../../AtomStore/store';
import {
  StyledContainer,
  StyledGoDot,
  StyledNavbar,
  StyledSpan,
} from './styles';

export const getFullPath = (constants, path) => {
  if (typeof path === 'string' && path.startsWith('https')) {
    return path;
  } else if (typeof path === 'string' && path.length === 0) {
    return path;
  } else {
    return constants?.ImagePath + path;
  }
};

const Header = () => {
  const [showBell,setShowBell] = useAtom(bell);
  const [child] = useAtom(childList);
  const [user, setUser] = useAtom(userstate);
  const [parent] = useAtom(parentProfile);
  const [collapse, setCollapse] = useAtom(sidebar);
  const [, setLoggedInChild] = useAtom(activeChildDetail);
  const [activeChild] = useAtom(activeChildDetail);
  const [, setShowOverlay] = useAtom(changeChild);
  const [constants]=useAtom(appConstants);
  const [state, setState] = useState({
    showOverLay: false,
    tooltipOpen: '',
  });
  const navigate = useNavigate();
  const childFullName =
    activeChild?.name +
    ' ' +
    (activeChild?.lastName ? activeChild?.lastName : '');

  const logo = {
    imgAlt: 'Footprints-Logo',
    imgSrc: require('../../../assets/Footprints-Logo.svg'),
  };

  let navbarBrandProps = {
    to: logo.innerLink,
    tag: Link,
  };

  const toggleTooltip = item => {
    setState({ ...state, tooltipOpen: item });
  };

  const showChildChangeOption = () => {
    setShowOverlay(true);
  };

  const isMultipleChild = () => {
    return Array.isArray(child) && child.length > 1;
  };

  return (
    <>
      <StyledNavbar>
        <StyledContainer>
          <button
            className="navbar-toggler d-lg-none"
            type="button"
            onClick={e => {
              e.preventDefault();
              setCollapse(true);
            }}
          >
            <span className="navbar-toggler-icon" />
          </button>
          {logo ? (
            <NavbarBrand
              className={`${
                collapse ? 'd-none' : 'd-inline-block'
              } navbar-brand-custom`}
              {...navbarBrandProps}
            >
              <img alt={logo.imgAlt} className="img-fluid" src={FootpringSvg} />
            </NavbarBrand>
          ) : null}
          <div className="d-flex align-items-center">
            <div className="">
              <Link className="d-flex align-items-center" to="/notification" onClick={()=>{
                setShowBell(false);
              }}>
                <i
                  className="icon-notification"
                  style={{ fontSize: '1.5em', color: '#777' }}
                  
                />
                {showBell ? <StyledGoDot /> : <></>}
              </Link>
            </div>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-" nav>
                <Media
                  style={{ cursor: isMultipleChild() ? 'pointer' : 'default' }}
                  className="align-items-center"
                >
                  {child?.map((ele, index) => (
                    <StyledSpan
                      key={index}
                      Img={getFullPath(constants, ele.childPhoto)}
                      onClick={e => {
                        e.preventDefault();
                        setLoggedInChild(ele);
                        parent.parentType === 'Mother'
                          ? setUser({
                              ...user,
                              password: ele?.motherPassword,
                            })
                          : setUser({
                              ...user,
                              password: ele?.fatherPassword,
                            });
                        parent.parentType === 'Mother'
                          ? setUser({
                              ...user,
                              password: ele?.motherPassword,
                            })
                          : setUser({
                              ...user,
                              password: ele?.fatherPassword,
                            });
                        navigate('/myprofile');
                      }}
                      style={{
                        backgroundImage: `url(${getFullPath(
                          constants,
                          ele.childPhoto
                        )})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        zIndex: 9,
                      }}
                      id={'Tooltip-' + index}
                      onMouseLeave={() =>
                        setState({
                          ...state,
                          showOverLay: false,
                          tooltipOpen: '',
                        })
                      }
                    >
                      <Tooltip
                        key={index}
                        placement="top"
                        isOpen={state.tooltipOpen === 'Tooltip-' + index}
                        target={'Tooltip-' + index}
                        toggle={() => toggleTooltip('Tooltip-' + index)}
                      >
                        {ele.name + ' ' + ele.lastName}
                      </Tooltip>
                    </StyledSpan>
                  ))}
                  <Media className="d-none d-lg-block">
                    <span
                      onClick={() => {
                        if (isMultipleChild()) showChildChangeOption();
                      }}
                      className="mb-0 text-sm font-weight-bold text-dark"
                      style={{
                        cursor: isMultipleChild() ? 'pointer' : 'default',
                      }}
                    >
                      {`${childFullName}`}
                      {isMultipleChild() && <FaAngleDown color="black" />}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
            </UncontrolledDropdown>
          </div>
        </StyledContainer>
      </StyledNavbar>
    </>
  );
};

export default Header;
